import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import logo from "../../../assets/img/logo.png";
import logo1 from "../../../assets/img/logo7.png";
import NaveItems from "./NaveItems";
import TopHeader from "./TopHeader";
import { useHistory } from "react-router-dom";
import svg from "../../../assets/img/svg/cancel.svg";

import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import {
  CART_URL,
  CHECKOUT_URL,
  getImageUrlPath,
  HOME_URL,
  PRODUCT_DETAILS_URL,
  SHOP_URL,
  WISHLIST_URL,
} from "../../../app/constants";
import ContactInfo from "./ContactInfo";

const Header = () => {
  const categories = useSelector((state) => state.products.categories);

  const menuItems = [{ name: "Home", href: HOME_URL }];

  const dispatch = useDispatch();

  categories.forEach((item) => {
    menuItems.push({
      name: item.name,
      mega_menu: true,
      children: item.ProductCategory.map((i) => ({
        name: i.name,
        href: SHOP_URL,
        onClick: () => {
          dispatch({
            type: "products/updateFilters",
            payload: { type: "category", filters: [{ id: item.id }] },
          });
          dispatch({
            type: "products/updateFilters",
            payload: { type: "subCategory", filters: [{ id: i.id }] },
          });
          dispatch({
            type: "products/updateFilters",
            payload: { type: "size", filters: [] },
          });
          dispatch({
            type: "products/updateFilters",
            payload: { type: "color", filters: [] },
          });
        },
      })),
    });
  });

  const [click, setClick] = useState(false);
  const [show, setShow] = useState(true);
  const history = useHistory();
  let carts = useSelector((state) => state.products.carts);
  let favorites = useSelector((state) => state.products.favorites);

  const rmCartProduct = (id) => {
    dispatch({ type: "products/removeCart", payload: { id } });
  };

  const rmFavProduct = (id) => {
    dispatch({ type: "products/removeFav", payload: { id } });
  };

  const cartTotal = () => {
    return carts.reduce(function (total, item) {
      return total + (item.count || 1) * item.totalPrice;
    }, 0);
  };

  const handleClick = () => {
    if (click) {
      document.querySelector("#offcanvas-add-cart").style =
        "transform: translateX(100%);";
    } else {
      document.querySelector("#offcanvas-add-cart").style =
        "transform: translateX(0%);";
    }
    setClick(!click);
  };
  const handleWish = () => {
    if (click) {
      document.querySelector("#offcanvas-wishlish").style =
        "transform: translateX(100%);";
    } else {
      document.querySelector("#offcanvas-wishlish").style =
        "transform: translateX(0);";
    }
    setClick(!click);
  };

  const handleSearch = () => {
    if (click) {
      document.querySelector("#search").style =
        "transform: translate(-100%, 0); opacity: 0";
    } else {
      document.querySelector("#search").style =
        "transform: translate(0px, 0px); opacity: 1";
    }
    setClick(!click);
  };
  const handleabout = () => {
    if (click) {
      document.querySelector("#offcanvas-about").style =
        "transform: translateX(100%);";
    } else {
      document.querySelector("#offcanvas-about").style =
        "transform: translateX(0%);";
    }
    setClick(!click);
  };
  const handlemenu = () => {
    if (click) {
      document.querySelector("#mobile-menu-offcanvas").style =
        "transform: translateX(100%);";
    } else {
      document.querySelector("#mobile-menu-offcanvas").style =
        "transform: translateX(0%);";
    }
    setClick(!click);
  };

  const handleShow = (value) => {
    value === show ? setShow("") : setShow(value);
  };

  // Sticky Menu Area
  useEffect(() => {
    window.addEventListener("scroll", isSticky);
    return () => {
      window.removeEventListener("scroll", isSticky);
    };
  });

  const isSticky = (e) => {
    const header = document.querySelector(".header-section");
    if (!header) return;
    const scrollTop = window.scrollY;
    scrollTop >= 250
      ? header.classList.add("is-sticky")
      : header.classList.remove("is-sticky");
  };

  return (
    <>

      <TopHeader />
      <header className="header-section d-none d-xl-block">
        <div className="header-wrapper">
          <div className="header-bottom header-bottom-color--golden section-fluid sticky-header sticky-color--golden">
            <div className="container">
              <div className="row">
                <div className="col-12 d-flex align-items-center justify-content-between">
                  <div className="header-logo">
                    <div className="logo">
                      <Link
                        to="/"
                        style={{
                          width: "110px",
                          height: "100px",
                          display: "flex",
                          padding: "3px",
                        }}
                      >
                        <img
                          style={{ width: "100%", height: "100%" }}
                          src={logo}
                          alt="logo"
                        />
                      </Link>
                    </div>
                  </div>
                  <div
                    className="main-menu menu-color--black menu-hover-color--golden d-none d-xl-block shadow-lg"
                    style={{
                      background:
                        "linear-gradient(to right,#540002,#1D4D57,#E8960F)",
                      borderRadius: "0 200px 0px 200px",
                      paddingLeft: "80px",
                      width: "850px",
                    }}
                  >
                    <nav>
                      <ul className="menu-list">
                        {menuItems.map((item, index) => (
                          <NaveItems item={item} key={index} />
                        ))}
                      </ul>
                    </nav>
                  </div>

                  <ul className="header-action-link action-color--black action-hover-color--golden">
                    <li>
                      {favorites.length ? (
                        <a className="offcanvas-toggle" onClick={handleWish}>
                          <i
                            style={{ color: "#E13685", fontSize: "2.00rem" }}
                            className="fa fa-heart"
                          ></i>
                          <span className="item-count">{favorites.length}</span>
                        </a>
                      ) : (
                        <a className="offcanvas-toggle">
                          <i
                            style={{ color: "#E13685", fontSize: "2.00rem" }}
                            className="fa fa-heart"
                          ></i>
                          <span className="item-count">{favorites.length}</span>
                        </a>
                      )}
                    </li>
                    <li>
                      {carts.length ? (
                        <a className="offcanvas-toggle" onClick={handleClick}>
                          <i
                            style={{ color: "#1B646D", fontSize: "2.00rem" }}
                            className="fa fa-cart-plus"
                          ></i>
                          <span className="item-count">{carts.length}</span>
                        </a>
                      ) : (
                        <a className="offcanvas-toggle">
                          <i
                            style={{ color: "#1B646D", fontSize: "2.00rem" }}
                            className="fa fa-cart-plus"
                          ></i>
                          <span className="item-count">{carts.length}</span>
                        </a>
                      )}
                    </li>

                    {/* <li>
                                            <a className="search_width" onClick={handleSearch} >
                                                <img src={svgsearch} alt="img" />
                                            </a>
                                        </li> */}
                    <li>
                      <a
                        className="offacnvas offside-about offcanvas-toggle"
                        onClick={handleabout}
                      >
                        <i className="fa fa-bars"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      <div className="mobile-header sticky-header sticky-color--golden mobile-header-bg-color--golden section-fluid d-lg-block d-xl-none">
        <div className="container">
          <div className="row">
            <div className="col-12 d-flex align-items-center justify-content-between">
              <div className="mobile-header-left">
                <ul className="mobile-menu-logo">
                  <li>
                    <Link to="/">
                      <div
                        className="logo"
                        style={{ width: "120px", height: "100px" }}
                      >
                        <img
                          src={logo}
                          alt="logo"
                          style={{ width: "100%", height: "100%" }}
                        />
                      </div>
                    </Link>
                  </li>
                </ul>
              </div>

              <div className="mobile-right-side">
                <ul className="header-action-link action-color--black action-hover-color--golden">
                  <li>
                    {favorites.length ? (
                      <a className="offcanvas-toggle" onClick={handleWish}>
                        <i className="fa fa-heart" style={{ color: "#E13685", fontSize: "2.00rem" }} ></i>
                        <span className="item-count">{favorites.length}</span>
                      </a>
                    ) : (
                      <a className="offcanvas-toggle">
                        <i className="fa fa-heart" style={{ color: "#E13685", fontSize: "2.00rem" }}></i>
                        <span className="item-count">{favorites.length}</span>
                      </a>
                    )}
                  </li>
                  <li>
                    {carts.length ? (
                      <a className="offcanvas-toggle" onClick={handleClick}>
                        <i style={{ color: "#1B646D", fontSize: "2.00rem" }} className="fa fa-cart-plus"></i>
                        <span className="item-count">{carts.length}</span>
                      </a>
                    ) : (
                      <a className="offcanvas-toggle">
                        <i style={{ color: "#1B646D", fontSize: "2.00rem" }} className="fa fa-cart-plus"></i>
                        <span className="item-count">{carts.length}</span>
                      </a>
                    )}
                  </li>
                  <li>
                    <a
                      className="offcanvas-toggle offside-menu"
                      onClick={handlemenu}
                    >
                      <i className="fa fa-bars"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        id="mobile-menu-offcanvas"
        className="offcanvas offcanvas-rightside offcanvas-mobile-menu-section"
        style={{ color: "white" }}
      >
        <div className="offcanvas-header text-right">
          <button className="offcanvas-close" onClick={handlemenu}>
            <img src={svg} alt="icon" />
          </button>
        </div>
        <div className="offcanvas-mobile-menu-wrapper">
          <div className="mobile-menu-bottom">
            <div className="offcanvas-menu">
              <ul>
                {menuItems.map((item) => (
                  <li key={item.name}>
                    <a
                      href={item.mega_menu ? undefined : item.href}
                      style={{ color: "white" }}
                      onClick={() => handleShow(item.name)}
                    >
                      <span>{item.name}</span>
                    </a>
                    {item.mega_menu && (
                      <>
                        {show === item.name ? (
                          <ul
                            className="mobile-sub-menu "
                            style={{ color: "white" }}
                          >
                            {item.children.map((i) => (
                              <li style={{ paddingLeft: "30px" }}>
                                <Link
                                  to={i.href}
                                  style={{ fontSize: "12px" }}
                                  onClick={() => {
                                    i.onClick();
                                    handlemenu();
                                  }}
                                >
                                  {i.name}
                                </Link>
                              </li>
                            ))}
                          </ul>
                        ) : null}
                      </>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="mobile-contact-info">
            <div className="logo">
              <Link to="/">
                <img style={{ borderRadius: "100%" }} src={logo1} alt="img" />
              </Link>
            </div>
            <ContactInfo />
            <ul className="user-link">
              <li>
                <Link to={WISHLIST_URL}>Wishlist</Link>
              </li>
              <li>
                <Link to={CART_URL}>Cart</Link>
              </li>
              <li>
                <Link to={CHECKOUT_URL}>Checkout</Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div
        id="offcanvas-about"
        className="offcanvas offcanvas-rightside offcanvas-mobile-about-section"
      >
        <div className="offcanvas-header text-right">
          <button className="offcanvas-close" onClick={handleabout}>
            <img src={svg} alt="icon" />
          </button>
        </div>
        <div className="mobile-contact-info">
          <ContactInfo />

          <ul className="user-link">
            <li>
              <Link to={WISHLIST_URL}>Wishlist</Link>
            </li>
            <li>
              <Link to={CART_URL}>Cart</Link>
            </li>
            <li>
              <Link to={CHECKOUT_URL}>Checkout</Link>
            </li>
          </ul>
        </div>
      </div>

      <div
        id="offcanvas-add-cart"
        className="offcanvas offcanvas-rightside offcanvas-add-cart-section"
      >
        <div className="offcanvas-header text-right">
          <button className="offcanvas-close" onClick={handleClick}>
            <img src={svg} alt="icon" />
          </button>
        </div>
        <div className="offcanvas-add-cart-wrapper">
          <h4 className="offcanvas-title">Shopping Cart</h4>
          <ul className="offcanvas-cart">
            {carts.map((data, index) => (
              <li className="offcanvas-wishlist-item-single" key={index}>
                <div className="offcanvas-wishlist-item-block">
                  <Link
                    to={`${PRODUCT_DETAILS_URL}/${data.productId}`}
                    className="offcanvas-wishlist-item-image-link"
                  >
                    <img
                      src={getImageUrlPath(data.image)}
                      alt="img"
                      className="offcanvas-wishlist-image"
                    />
                  </Link>
                  <div className="offcanvas-wishlist-item-content">
                    <Link
                      to={`${PRODUCT_DETAILS_URL}/${data.productId}`}
                      className="offcanvas-wishlist-item-link"
                    >
                      {data.name}
                    </Link>
                    <div className="offcanvas-wishlist-item-details">
                      <span className="offcanvas-wishlist-item-details-quantity">
                        {data.quantity || 1} x
                      </span>
                      <span className="offcanvas-wishlist-item-details-price">
                        {" "}
                        ₹{data.totalPrice}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="offcanvas-wishlist-item-delete text-right">
                  <a
                    className="offcanvas-wishlist-item-delete"
                    onClick={() => rmCartProduct(data.id)}
                  >
                    <i className="fa fa-trash"></i>
                  </a>
                </div>
              </li>
            ))}
          </ul>
          <div className="offcanvas-cart-total-price">
            <span className="offcanvas-cart-total-price-text">Subtotal:</span>
            <span className="offcanvas-cart-total-price-value">
              ₹{cartTotal()}.00
            </span>
          </div>
          <ul className="offcanvas-cart-action-button">
            <li>
              <Link
                to={CART_URL}
                className="theme-btn-one btn-black-overlay btn_md"
              >
                View Cart
              </Link>
            </li>
            <li>
              <Link
                to={CHECKOUT_URL}
                className="theme-btn-one btn-black-overlay btn_md"
              >
                Checkout
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div
        id="offcanvas-wishlish"
        className="offcanvas offcanvas-rightside offcanvas-add-cart-section"
      >
        <div className="offcanvas-header text-right">
          <button className="offcanvas-close" onClick={handleWish}>
            <img src={svg} alt="icon" />
          </button>
        </div>
        <div className="offcanvas-wishlist-wrapper">
          <h4 className="offcanvas-title">Wishlist</h4>

          <ul className="offcanvas-wishlist">
            {favorites.map((data, index) => (
              <li className="offcanvas-wishlist-item-single" key={index}>
                <div className="offcanvas-wishlist-item-block">
                  <Link
                    to={`${PRODUCT_DETAILS_URL}/${data.id}`}
                    className="offcanvas-wishlist-item-image-link"
                  >
                    <img
                      src={data.img}
                      alt="img"
                      className="offcanvas-wishlist-image"
                    />
                  </Link>
                  <div className="offcanvas-wishlist-item-content">
                    <Link
                      to={`${PRODUCT_DETAILS_URL}/${data.id}`}
                      className="offcanvas-wishlist-item-link"
                    >
                      {data.title}
                    </Link>
                    <div className="offcanvas-wishlist-item-details">
                      <span className="offcanvas-wishlist-item-details-quantity">
                        1 x
                      </span>
                      <span className="offcanvas-wishlist-item-details-price">
                        ₹{data.price}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="offcanvas-wishlist-item-delete text-right">
                  <a
                    className="offcanvas-wishlist-item-delete"
                    onClick={() => rmFavProduct(data.id)}
                  >
                    <i className="fa fa-trash"></i>
                  </a>
                </div>
              </li>
            ))}
          </ul>
          <ul className="offcanvas-wishlist-action-button">
            <li>
              <Link
                to={WISHLIST_URL}
                className="theme-btn-one btn-black-overlay btn_md"
              >
                View wishlist
              </Link>
            </li>
          </ul>
        </div>
      </div>

      <div id="search" className="search-modal">
        <button type="button" className="close" onClick={handleSearch}>
          <img src={svg} alt="icon" />
        </button>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleSearch();
            Swal.fire("Success", "Check out the Results", "success");
            history.push("/shop");
          }}
        >
          <input type="search" placeholder="type keyword(s) here" required />
          <button type="submit" className="btn btn-lg btn-main-search">
            Search
          </button>
        </form>
      </div>
    </>
  );
};

export default Header;
